module.exports = __webpack_public_path__ + "static/media/logo-opquast.f28e1726.png";